import React from 'react'


//React strap
import {Modal,ModalBody} from "reactstrap"
import Cargando from './Cargando'

export type sizePropsModal =  "xl" | "sm" | "md";

type PropsModalCargando = {
    textoCargando?:string,
    show:boolean
    onClose:() => void,
    size:sizePropsModal
}
export default function ModalCargando(props:PropsModalCargando) {

    return (
        <Modal
            isOpen={props.show}
            scrollable={true}
            size={props.size}
            fullscreen={props.size}
            centered={true}
            onClosed={props.onClose}
        >
            <ModalBody>
                <Cargando mensaje={props.textoCargando} />
            </ModalBody>
        </Modal>
    )
}
